"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "casatenovo": {
    "b94a6a02": [{
      "hkey": "3d0a85d8",
      "slug": "cassina-de-bracchi-valaperta",
      "name": "Cassina de' Bracchi-Valaperta",
      "primary": true,
      "skipSearch": false
    }],
    "cassina-de-bracchi": [{
      "hkey": "3d0a85d8",
      "slug": "cassina-de-bracchi-valaperta",
      "name": "Cassina de' Bracchi-Valaperta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4f34a461": [{
      "hkey": "ad961068",
      "slug": "rogoredo-rimoldo",
      "name": "Rogoredo-Rimoldo",
      "primary": true,
      "skipSearch": false
    }],
    "rimoldo": [{
      "hkey": "ad961068",
      "slug": "rogoredo-rimoldo",
      "name": "Rogoredo-Rimoldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "casatenovo"
    }],
    "66b70110": [{
      "hkey": "ad961068",
      "slug": "rogoredo-rimoldo",
      "name": "Rogoredo-Rimoldo",
      "primary": true,
      "skipSearch": false
    }],
    "rogoredo": [{
      "hkey": "ad961068",
      "slug": "rogoredo-rimoldo",
      "name": "Rogoredo-Rimoldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "391343a2": [{
      "hkey": "3d0a85d8",
      "slug": "cassina-de-bracchi-valaperta",
      "name": "Cassina de' Bracchi-Valaperta",
      "primary": true,
      "skipSearch": false
    }],
    "valaperta": [{
      "hkey": "3d0a85d8",
      "slug": "cassina-de-bracchi-valaperta",
      "name": "Cassina de' Bracchi-Valaperta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "casatenovo"
    }]
  }
};
exports["default"] = _default;